/* Lawazen Next - brand explorer. Build 2026-09-06-p2b
   Level 3 is fetched from /collections/<handle>?view=lz-panel, a bare Liquid
   template, so filtering, sorting and pagination stay Shopify's own and the
   catalogue is never shipped to the browser. */
(function () {
  'use strict';

  function explorer(root) {
    if (root.dataset.lzBound) return; root.dataset.lzBound = '1';
    var view = root.dataset.lzView || 'lz-panel';
    var levels = {};
    root.querySelectorAll('[data-lz-level]').forEach(function (el) { levels[el.dataset.lzLevel] = el; });
    var panel = root.querySelector('[data-lz-panel]');
    var crumbBrand = root.querySelector('[data-lz-crumb-brand]');
    var crumbColl = root.querySelector('[data-lz-crumb-collection]');
    var seps = root.querySelectorAll('[data-lz-sep]');
    var st = { brand: '', handle: '', title: '' };

    function show(level) {
      Object.keys(levels).forEach(function (k) { levels[k].hidden = k !== level; });
      if (crumbBrand) { crumbBrand.hidden = !st.brand; crumbBrand.textContent = st.brand; }
      if (crumbColl) { crumbColl.hidden = level !== 'products'; crumbColl.textContent = st.title; }
      if (seps[0]) seps[0].hidden = !st.brand;
      if (seps[1]) seps[1].hidden = level !== 'products';
    }

    root.querySelectorAll('[data-lz-brand]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        st.brand = btn.dataset.lzBrand; st.handle = ''; st.title = '';
        /* scoped to the grids: the tiles carry the same attribute */
        root.querySelectorAll('.lz-collgrid[data-lz-brandpanel]').forEach(function (g) {
          g.hidden = g.dataset.lzBrandpanel !== btn.dataset.lzBrandpanel;
        });
        show('collections');
      });
    });

    root.addEventListener('click', function (e) {
      var card = e.target.closest('[data-lz-collection]');
      if (card && root.contains(card)) {
        e.preventDefault();
        st.handle = card.dataset.lzCollection;
        st.title = card.dataset.lzTitle || st.handle;
        show('products');
        load('/collections/' + st.handle + '?view=' + view);
        return;
      }
      var back = e.target.closest('[data-lz-back]');
      if (back && root.contains(back)) {
        e.preventDefault();
        var to = back.dataset.lzBack;
        if (to === 'brands') { st.brand = ''; st.handle = ''; st.title = ''; }
        if (to === 'collections') { st.handle = ''; st.title = ''; }
        show(to);
      }
    });

    function load(url) {
      if (!panel) return;
      panel.classList.add('is-loading');
      if (!panel.innerHTML.trim()) panel.innerHTML = '<div class="lz-spinner">Loading…</div>';
      fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) {
          panel.innerHTML = html;
          panel.classList.remove('is-loading');
          bindPanel(url);
        })
        .catch(function () {
          panel.classList.remove('is-loading');
          panel.innerHTML = '<div class="lz-empty"><h3>That list did not load</h3>'
            + '<p>Open the collection directly instead.</p>'
            + '<p><a class="lz-btn lz-btn--glass" href="/collections/' + st.handle + '">View collection</a></p></div>';
        });
    }

    function paramsOf(url) {
      var q = url.indexOf('?');
      return new URLSearchParams(q < 0 ? '' : url.slice(q + 1));
    }

    function bindPanel(currentUrl) {
      var form = panel.querySelector('[data-lz-filters]');
      if (form) {
        var run = function () {
          var p = new URLSearchParams(new FormData(form));
          var out = new URLSearchParams();
          out.set('view', view);
          p.forEach(function (v, k) { if (v !== '' && k !== 'view') out.append(k, v); });
          load('/collections/' + st.handle + '?' + out.toString());
        };
        form.addEventListener('submit', function (e) { e.preventDefault(); run(); });
        form.addEventListener('change', run);
        var reset = panel.querySelector('[data-lz-reset]');
        if (reset) reset.addEventListener('click', function (e) {
          e.preventDefault();
          load('/collections/' + st.handle + '?view=' + view);
        });
      }
      panel.querySelectorAll('[data-lz-page]').forEach(function (a) {
        a.addEventListener('click', function (e) {
          e.preventDefault();
          var p = paramsOf(currentUrl);
          p.set('view', view);
          p.set('page', a.dataset.lzPage);
          load('/collections/' + st.handle + '?' + p.toString());
        });
      });
      panel.querySelectorAll('[data-lz-removefilter]').forEach(function (b) {
        b.addEventListener('click', function (e) {
          e.preventDefault();
          var p = paramsOf(currentUrl);
          p.delete(b.dataset.lzRemovefilter);
          p.set('view', view);
          load('/collections/' + st.handle + '?' + p.toString());
        });
      });
    }
  }

  window.lzExploreInit = function (scope) {
    (scope || document).querySelectorAll('[data-lz-explore]').forEach(explorer);
    if (window.lzFinderInit) window.lzFinderInit(scope);
  };
  if (window.lzInit) window.lzExploreInit(document);
})();
